// extracted by mini-css-extract-plugin
export default {"dialog":"dialog__73Vou","dialogContent":"dialogContent__5PJg-","dialogHead":"dialogHead__+0USw","dialogClose":"dialogClose__2n6BK"};